export default "__VITE_ASSET__57e8b58b__"